module.exports = __webpack_public_path__ + "img/Avatar-24.64fb8ef3.svg";